import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { AuditFormMechanicalPageContainer } from './audit-form-mechanical-page.container';
import { useAuditFormMechanicalPageViewModel } from './audit-form-mechanical-page.view-model';

export const AuditFormMechanicalPage = () => {
  const logger = useLogger('pages/audit-form-mechanical');

  const viewModel = useAuditFormMechanicalPageViewModel({
    auditFormService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Mechanical">
      <AuditFormMechanicalPageContainer viewModel={viewModel} logger={logger} />
    </NestedPageLayout>
  );
};
